import { gql } from "@apollo/client";

export const PROCESAR_PRECIO_MASIVO = gql`
    mutation ProcesarPrecioMasivo(
        $idPrecioMasivo: Int!,
        $idUsuario: Int!,
        $idUsuarioAutorizador: Int!,
        $observaciones: String!,
        $idUsuarioSolicitante: Int!
    ){
    procesarPrecioMasivo(
        input : {
            idPrecioMasivo: $idPrecioMasivo,
            idUsuario: $idUsuario,
            idUsuarioAutorizador: $idUsuarioAutorizador,
            observaciones: $observaciones,
            idUsuarioSolicitante: $idUsuarioSolicitante
        }            
    ) 
}
`;